import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '@learningblocks/storybook-components';

const BUTTON_ACTIVE = 'active';
const BUTTON_INACTIVE = 'inactive';

/**
 * Level Selection Button for LevelSelector of ExperimentalDesign
 */
export function LevelButton(props) {
  const onClick = (event) => {
    event.preventDefault();
    props.onClick(props.levelID);
  };

  const getButtonStateClassName = () =>
    props.selected ? BUTTON_ACTIVE : BUTTON_INACTIVE;

  const getClassName = () => `${props.className} ${getButtonStateClassName()}`;

  return (
    <Button
      tabIndex={props.tabIndex}
      className={getClassName()}
      onClick={onClick}>
      {props.children}
    </Button>
  );
}

LevelButton.propTypes = {
  /**
   * TabIndex value to set for the button
   */
  tabIndex: PropTypes.number.isRequired,
  /**
   * ID for the button level
   */
  levelID: PropTypes.number.isRequired,
  /**
   * Callback function to be executed when clicked on
   */
  onClick: PropTypes.func.isRequired,
  /**
   * Stringvalue to set for as className
   */
  className: PropTypes.string.isRequired,
  /**
   * Element/String to be displayed inside the button
   */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  /**
   * Boolean specifying if the level is selected
   */
  selected: PropTypes.bool.isRequired,
};

LevelButton.defaultProps = {
  className: 'level-selection__levelbutton',
  tabIndex: 0,
  children: 'Level',
  selected: false,
};
